export default __webpack_public_path__ + "static/media/point_icon.7ca57fde.svg";